module.exports = __webpack_public_path__ + "img/12.91b2315b.jpg";